import { render, staticRenderFns } from "./FooterButtonCourse.vue?vue&type=template&id=36661577&scoped=true"
import script from "./FooterButtonCourse.vue?vue&type=script&lang=js"
export * from "./FooterButtonCourse.vue?vue&type=script&lang=js"
import style0 from "./FooterButtonCourse.vue?vue&type=style&index=0&id=36661577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36661577",
  null
  
)

export default component.exports